import { BaseSearchAutocompleteCustom, BaseSearchStrategy } from "@/Common/Components/Search/BaseSearchAutocompleteCustom";
import { ValueCodeDropdownItem } from "@/Patient/Components/MedicalItems/Immunization/ValueCodeDropdownItem";
import { CodeValue } from "../Models/CodeValue";

class CodeValueSearchAutocompleteCustom extends BaseSearchAutocompleteCustom<CodeValue> {
    protected defaultSearchStrategy = null;

    protected renderLabel(model: CodeValue): string {
        return model?.Label;
    }

    protected searchStrategyRenderItem(model: CodeValue, cssClass?: string): React.ReactNode {
        return <div className={cssClass}><span>{this.renderLabel(model)}</span></div>;
    }

    protected getItemId(model: CodeValue): string {
        return model?.Code;
    }
}

class CodeValueSearchStrategy extends BaseSearchStrategy<CodeValue> {
    public id: string;
    private valueToSearchFrom: CodeValue[];

    constructor(values: CodeValue[], customId: string = null, addSelectAll: boolean = false) {
        super();

        this.id = customId || "RvqCodeValueSearch";
        this.valueToSearchFrom = addSelectAll
            ? this.addSelectAllOption(values)
            : values;
    }

    public async executeSearch(searchText: string): Promise<ValueCodeDropdownItem[]> {
        let results: ValueCodeDropdownItem[] = [];
        if (!searchText) {
            results = this.valueToSearchFrom
                .map((p, index) => p.toCodeValueDropdownItem(index === 0));
        }
        else {
            results = this.valueToSearchFrom
                .map(p => p.ToSearchableItem(true))
                .filterSearch(searchText, p => p.Value_Searchable)
                .sortByPropertyDesc(p => p.Value)
                .map((p, idx) => p.Model.toCodeValueDropdownItem(idx === 0));
        }

        return new Promise((resolve => resolve(results)));
    }

    private addSelectAllOption(codeValues: CodeValue[]): CodeValue[] {
        const selectAllOption = new CodeValue({
            Label: cacheStore.GetString("SelectAllLabel"),
            Code: "SelectAll"
        });

        return [selectAllOption, ...codeValues];
    }
}

export { CodeValueSearchAutocompleteCustom, CodeValueSearchStrategy };
